
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountReceivableGrid extends Serenity.EntityGrid<PartyBalanceRow, any> {
        protected getColumnsKey() { return 'Finance.AccountReceivable'; }
        protected getDialogType() { return PartyBalanceDialog; }
        protected getIdProperty() { return PartyBalanceRow.idProperty; }
        protected getInsertPermission() { return PartyBalanceRow.insertPermission; }
        protected getLocalTextPrefix() { return PartyBalanceRow.localTextPrefix; }
        protected getService() { return AccountReceivableService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            //this.view.setGrouping([{

            //    getter: 'LedgerName',
            //    displayTotalsRow: false,

            //}, {
            //    getter: 'VoucherTypeName',

            //    displayTotalsRow: false

            //}])

            return grid;
        }


        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Account Receivable"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}